import { PageTypeEnum } from 'common/enums/PageTypeEnum'
import { AutomationRuleActionsEnum } from '../types/automation-rules/actions-types'

export const pagesWithAutomationRulesTypes = [
  PageTypeEnum.Squeeze,
  PageTypeEnum.OptInThankYou,
  PageTypeEnum.Popup,
  PageTypeEnum.Inline,
  PageTypeEnum.SalesPage,
  PageTypeEnum.OfferThankYouPage,
  PageTypeEnum.InfoPage,
  PageTypeEnum.BlogHome,
  PageTypeEnum.BlogStatic,
  PageTypeEnum.BlogSearch,
  PageTypeEnum.BlogPostListing,
]

export const AutomationRuleActions = [
  AutomationRuleActionsEnum.add_tag,
  AutomationRuleActionsEnum.subscribe_to_campaign,
  AutomationRuleActionsEnum.send_email,
  AutomationRuleActionsEnum.send_email_to_specific_address,
  AutomationRuleActionsEnum.enroll_in_course,
  AutomationRuleActionsEnum.enroll_in_course_bundle,
  AutomationRuleActionsEnum.send_webhook,
  AutomationRuleActionsEnum.grant_access_to_community,
  AutomationRuleActionsEnum.remove_tag,
  AutomationRuleActionsEnum.unsubscribe_from_campaign,
  AutomationRuleActionsEnum.revoke_access_to_course,
  AutomationRuleActionsEnum.revoke_access_to_course_bundle,
  AutomationRuleActionsEnum.revoke_access_to_community,
  AutomationRuleActionsEnum.create_user,
]
